const ViewOnlyWrapper = ({ viewOnly = false, children }) => {
  return (
    <div style={{ position: "relative" }}>
      {viewOnly && <div style={styles.banner}>🔒 View-only mode — editing is disabled</div>}

      <div
        className={viewOnly ? "view-only-wrapper__content view-only-wrapper__content--readonly" : "view-only-wrapper__content"}
        style={{
          opacity: viewOnly ? 0.8 : 1,
        }}
      >
        {children}
      </div>
    </div>
  );
};
  
  const styles = {
    banner: {
      color: "#856404",
      padding: "8px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontSize: "16px",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
  };
  
  export default ViewOnlyWrapper;
  